import {
  SchemaDatapoint,
  SchemaItem,
  SchemaSection,
} from '@rossum/api-client/schemas';
import { assertNever } from '../../../lib/typeUtils';

export type SchemaDatapointWithParent = SchemaDatapoint & {
  parentMultivalueSchemaId: string | undefined;
};

const flattenDatapoint = <T extends SchemaItem | SchemaSection>(
  item: T,
  parentMultivalueSchemaId: string | undefined = undefined
): SchemaDatapointWithParent[] => {
  if (item.category === 'datapoint') {
    return [
      {
        ...item,
        parentMultivalueSchemaId,
      },
    ];
  }

  if (item.category === 'multivalue') {
    return flattenDatapoint(item.children, item.id);
  }

  if (item.category === 'tuple') {
    return item.children.flatMap(c =>
      flattenDatapoint(c, parentMultivalueSchemaId)
    );
  }

  if (item.category === 'section') {
    return item.children.flatMap(c =>
      flattenDatapoint(c, parentMultivalueSchemaId)
    );
  }

  return assertNever(item);
};

export const flattenDatapoints = (
  schemaContent: SchemaSection[]
): SchemaDatapointWithParent[] => {
  return schemaContent.flatMap(c => flattenDatapoint(c));
};
